import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGeocoderAddress } from '../object-history-common.models';
import { ICoordinatesViewModel } from 'app/system/mobile-models/profile-models';

@Injectable({ providedIn: 'root' })
export class ReverseGeocoderService {
  constructor(private http: HttpClient) {}

  reverseGeocode(coords: ICoordinatesViewModel[]): Observable<IGeocoderAddress[]> {
    return this.http.post<IGeocoderAddress[]>(
      '/ctrl/ReverseGeocoder/reverse-geocode',
      coords
    );
  }
}
